/**
 * 编组 / 取消编组：与 Ctrl/Cmd+G、Shift+Ctrl+G 同能力，挂到图层快捷条。
 */
import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { GroupLayerHotkeyType } from '../../../../type';
import { groupPackShortcutItem } from './group-pack-item';
import { GroupUnpackShortcutItem } from './group-unpack-item';

const GroupLayerShortcutMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);

        framework.service.registration.getInstance<ShortcutMenu>('ShortcutMenu').addItems([
            {
                key: GroupLayerHotkeyType.UNPACK,
                sort: 40,
                render: ({ framework, id }) => <GroupUnpackShortcutItem framework={framework} id={id} />,
            },
            {
                key: GroupLayerHotkeyType.PACK,
                sort: 50,
                render: groupPackShortcutItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'group-layer-shortcut-menu',
    render() {
        return <GroupLayerShortcutMenuView />;
    },
};

export default exportPlugin;
